import React from 'react';
import { Dialog, Button } from '@blueprintjs/core';
import {
  FlexRow,
  PaddingWrapper,
  PlainButton,
} from 'components/styled-components';
import jwt_decode from 'jwt-decode';
import { refreshToken } from 'api/users';
class DialogSessionWrapper extends React.Component {
  //Not included in the state to prevent unecessary rerendering
  intervalExpiryCheckID = 0;
  intervalLogoutID = 0;
  intervalCountID = 0;

  state = {
    isOpen: false,
    logoutTimer: null,
    expTime: {},
    timeLeft: null,
  };

  componentDidMount() {
    this.startIntervalExpiryCheck();
    let decodedBrowserToken = {};
    if (sessionStorage.getItem('token')) {
      decodedBrowserToken = jwt_decode(sessionStorage.getItem('token'));
    }
    this.setState({
      expTime: decodedBrowserToken,
    });
    this.props.getIntervalID(this.intervalExpiryCheckID);
  }

  componentDidUpdate(prevProps) {
    let decodedBrowserToken = {};
    if (sessionStorage.getItem('token')) {
      decodedBrowserToken = jwt_decode(sessionStorage.getItem('token'));
    }
    if (this.props.appUser && prevProps.appUser) {
      if (this.state.expTime) {
        if (decodedBrowserToken.exp !== this.state.expTime.exp) {
          this.setState({
            expTime: decodedBrowserToken,
          });
        }
      }
    }
  }

  startIntervalExpiryCheck = () => {
    this.intervalExpiryCheckID = setInterval(() => {
      if (this.state.expTime) {
        if (
          this.state.expTime.exp - Date.now() / 1000 <
            Number(process.env.REACT_APP_SESSION_TIMEOUT) &&
          !this.state.isOpen
        ) {
          this.setState({
            isOpen: true,
          });
          this.startLogoutTimer(this.intervalExpiryCheckID);
        }
      }
    }, 1000);
  };

  /* startLogoutTimer starts a timer that lasts the remaining number of
     seconds before the user's session times out. */
  startLogoutTimer(interval) {
    this.intervalLogoutID = setTimeout(() => {
      if (this.state.expTime.exp) {
        this.stopLogoutTimer();
        clearInterval(this.intervalExpiryCheckID);
        this.setState({ isOpen: false, expTime: {}, logoutTimer: null });
        this.props.logout();
      } else {
        this.setState({ isOpen: false, expTime: {}, logoutTimer: null });
      }
    }, this.state.expTime.exp * 1000 - Date.now());

    this.setState({
      timeLeft: this.formatTime(),
      logoutTimer: this.intervalLogoutID,
    });

    this.countDown();
  }

  //Count down the seconds from pop up to log out
  countDown() {
    this.intervalCountID = setInterval(() => {
      let time = this.state.timeLeft;
      if (time) {
        //Get formatted time mm:ss
        let [minutes, seconds] = time.split(':').map(Number);
        if (seconds === 0) {
          minutes--;
          seconds = 59;
        } else {
          seconds--;
        }
        //if seconds/minute single digit insert a leading zero
        seconds = seconds < 10 ? '0' + seconds : seconds;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        time = minutes + ':' + seconds;

        this.setState({ timeLeft: time });
      }
    }, 1000);
  }

  //Format time on the pop up to logout as mm:ss
  formatTime() {
    let seconds = Math.ceil(this.state.expTime.exp - Date.now() / 1000);
    let minutes = (seconds - (seconds %= 60)) / 60;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    return minutes + ':' + seconds;
  }

  //Refresh User Token on Continue
  refreshUserToken = async () => {
    refreshToken(sessionStorage.getItem('token'))
      .then(res => {
        //If the token was fetched close the popup
        this.setState({ isOpen: false });
        this.stopLogoutTimer();

        //save the token in the browser
        sessionStorage.setItem('token', res.data.jwt_token);
        this.setState({ expTime: jwt_decode(res.data.jwt_token) });
      })
      .catch(err => {
        //if an error occured while fetching, close the popup and logout
        clearInterval(this.intervalExpiryCheckID);
        this.closeDialog();
      });
  };

  stopLogoutTimer() {
    clearTimeout(this.intervalLogoutID);
    clearTimeout(this.intervalCountID);
    this.setState({ logoutTimer: null });
  }

  closeDialog = () => {
    // hide html dialog box
    this.setState({ isOpen: false, expTime: {} });
    // cancel timeout timer
    this.stopLogoutTimer();
    clearInterval(this.intervalExpiryCheckID);
    //logout user
    this.props.logout();
  };

  render() {
    return (
      <Dialog
        isOpen={this.state.isOpen}
        onClose={this.closeDialog}
        title={'Session Expiring Soon'}
        isCloseButtonShown={false}
        canOutsideClickClose={false}
      >
        <PaddingWrapper>{`Your session will expire in ${this.state.timeLeft}.`}</PaddingWrapper>
        <FlexRow justify="flex-end">
          <Button minimal onClick={this.closeDialog}>
            END
          </Button>
          <PlainButton onClick={this.refreshUserToken}>CONTINUE</PlainButton>
        </FlexRow>
      </Dialog>
    );
  }
}

export default DialogSessionWrapper;
